export const experiment = (localStorageItem, value) =>
  typeof window !== 'undefined' &&
  localStorage.getItem(localStorageItem) === value
